import React from "react";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Chip,
  Box,
  InputAdornment,
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ListIcon from '@mui/icons-material/List';

const BusinessUnitSelect = ({
  businessUnits,
  multiselect=false,
  selectedValues,
  onChange,
  ...props
}) => {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onChange(value);
  };
  const handleDelete = (valueToDelete) => () => {
    const newValues = selectedValues.filter((value) => value !== valueToDelete);
    onChange(newValues);
  };
  return (
    <FormControl sx={{ width: "100%" ,mt:2}}>
      <InputLabel sx={{ ml: 3.5, backgroundColor: "white" }}>
        Select BusinessUnit
      </InputLabel>
      <Select
        multiple={multiselect}
        IconComponent={ArrowDropDownIcon}
        InputProps={{
            startAdornment: (
              <InputAdornment position="start">
               <ListIcon/>
              </InputAdornment>
            ),
          }}
        value={selectedValues}
        onChange={handleChange}
        renderValue={(selected) => (
            <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((id) => {
                const option = businessUnits.find((opt) => opt.businessUnitId === id);
                return option ? (
                  <Chip
                    key={id}
                    label={`${option.businessUnitName === null ? 'N/A' : option.businessUnitName}`}
                    onDelete={handleDelete(id)}
                    size="small"
                    color="info"
                    variant="outlined"
                    sx={{ height: '24px' ,ml:1,mt:1 }}
                    onMouseDown={(e) => e.stopPropagation()} // Prevents select from closing
                  />
                ) : null;
              })}
            </Box>)}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "50px", // Adjust this value for more/less rounding
            legend: {
              marginLeft: "30px",
            },
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderRadius: "50px",
            legend: {
              marginLeft: "30px",
            },
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderRadius: "50px",
            legend: {
              marginLeft: "30px",
            },
          },
          '& .MuiSelect-icon': {
            color: 'action.active',
          },
          '& .MuiInputBase-input': {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '8px', // Add some spacing after the icon
          },
        }}
        {...props}
      >
        {businessUnits.map((option) => (
          <MenuItem key={option.businessUnitId} value={option.businessUnitId}>
            <Checkbox checked={selectedValues.indexOf(option.businessUnitId) > -1} />
            <ListItemText
              primary={`${option.businessUnitId}-${
                option.businessUnitName === null ? "N/A" : option.businessUnitName
              }`}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BusinessUnitSelect;
